import React from "react";
import {CodeComponent} from "../../../../app/components/code/CodeComponent";

export function HashSetInsertUnhappyFullCaption() {
    return (<div className="captionParagraphs">
        <HashSetInsertUnhappy1/>
    </div>)
}

export function HashSetInsertUnhappy1() {
    return (<p>When we reached our ideal capacity (50% in this example), we must resize, and therefore, <CodeComponent
            className="codeHash">REHASH</CodeComponent> every <CodeComponent
            className="codeValue">VALUE</CodeComponent> in our HashSet. If we have <CodeComponent>n</CodeComponent>
            <CodeComponent className="codeValue">VALUES</CodeComponent> in our HashSet, then our time complexity will
            be <CodeComponent>O(n)</CodeComponent>.</p>)
}
